import type { Question } from '@/features/gameSession/types';
import type { BouncySumsSceneStatus } from '@/features/bouncySums/constants';

export enum BouncySumsSpeedChange {
	None = 'none',
	SpeedUp = 'speed-up',
	SlowDown = 'slow-down',
}

export interface BouncySumsLabels {
	audioToggleTooltip: string;
	bpmLabel: string;
	endTitle: string;
	motivationalMessages: string[];
	otherTables: string;
	playAll: string;
	playSelection: string;
	previousHighScoreLabel: string;
	replay: string;
	scoreLabel: string;
	secondsSuffix: string;
	speedupMessage: string;
	startTitle: string;
	tablesAnsweredLabel: string;
	tablesLabel: string;
	tip: string;
	topicTitle: string;
}

export interface BouncySumsConfig {
	gameTimeSeconds: number;
	bpm: number;
	tables: number[];
	playlistSections: Partial<Record<number, number>>;
	highScore: number;
	speedupMessage: string;
	motivationalMessages: string[];
}

export type BouncySumsTableKey = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10';

export interface BouncySumsGameData {
	type: 'BouncySumsGame';
	high_score: number;
	game_time: number;
	title: string;
	game_name: string;
	color_name: string;
	motivation_messages: string[];
	speedup_message: string;
	playlist_sections: Record<BouncySumsTableKey, number>;
}

export interface BouncySumsQuestionsRequestEvent {
	playlistSectionIds: number[];
	selectedTables: number[];
}

export interface BouncySumsQuestion {
	id: string;
	question: string;
	answer: string;
	table: string;
	score: number;
	sourceQuestion?: Question;
}

export interface BouncySumsAnswerRecord {
	answer_time_in_ms: number;
	is_correct: boolean;
	table: string;
	question: string;
	question_id?: string;
}

export interface BouncySumsSceneAnswerEvent {
	question: BouncySumsQuestion;
	questionIndex: number;
	attemptNumber: number;
	answerRecord: BouncySumsAnswerRecord;
	isCorrect: boolean;
	madeMistake: boolean;
	currentAnswer: string;
	score: number;
	bpm: number;
	speedChange: BouncySumsSpeedChange;
}

export interface BouncySumsSceneFinishEvent {
	finished: boolean;
	correct_count: number;
	bpm: number;
	score: number;
	is_high_score: boolean;
	previous_high_score: number;
	selected_tables: number[];
	answers: BouncySumsAnswerRecord[];
}

export interface BouncySumsSceneStateEvent {
	status: BouncySumsSceneStatus;
	score: number;
	bpm: number;
	progress: number;
	timeRemainingSeconds: number;
	answeredCount: number;
	isHighScore: boolean;
	previousHighScore: number;
	currentQuestion?: BouncySumsQuestion;
}
